<!-- Базовый заголовок - Atom -->
<template>
  <component
    :is="tag"
    :class="[
      'font-heading font-semibold leading-tight',
      sizeClasses,
      colorClasses,
      alignClasses,
      gradientClasses
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  /** HTML тег заголовка */
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
  /** Размер заголовка */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl'
  /** Цвет текста */
  color?: 'default' | 'primary' | 'muted' | 'white' | 'gradient'
  /** Выравнивание */
  align?: 'left' | 'center' | 'right'
  /** Использовать градиент из дизайна */
  gradient?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  tag: 'h2',
  size: 'lg',
  color: 'default',
  align: 'left',
  gradient: false
})

// Классы размеров (соответствуют дизайну Figma)
const sizeClasses = computed(() => {
  switch (props.size) {
    case 'xs':
      return 'text-xs'
    case 'sm':
      return 'text-sm'
    case 'md':
      return 'text-base'
    case 'lg':
      return 'text-lg'
    case 'xl':
      return 'text-xl'
    case '2xl':
      return 'text-2xl'
    case '3xl':
      return 'text-3xl'
    case '4xl':
      return 'text-4xl'
    default:
      return 'text-lg'
  }
})

// Классы цветов
const colorClasses = computed(() => {
  if (props.gradient) return ''
  
  switch (props.color) {
    case 'primary':
      return 'text-primary'
    case 'muted':
      return 'text-muted'
    case 'white':
      return 'text-white'
    case 'gradient':
      return ''
    default:
      return 'text-foreground'
  }
})

// Классы выравнивания
const alignClasses = computed(() => {
  switch (props.align) {
    case 'center':
      return 'text-center'
    case 'right':
      return 'text-right'
    default:
      return 'text-left'
  }
})

// Градиентные классы (как в дизайне Figma)
const gradientClasses = computed(() => {
  if (props.gradient || props.color === 'gradient') {
    return 'text-gradient'
  }
  return ''
})
</script>







